// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"7293b787","314":"a4a06f53","496":"d86dd6d3","659":"2e25e021","727":"517afe7f"}[chunkId] + ".chunk.js";
};